import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import './index.css';

const  ModalLoading = ({show, content}) => {
  return (
    <Modal
      show={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size='sm'
    >
      <Modal.Body className='content_noti_modal_loading'>
        <Spinner
          as="span"
          animation="border"
          style={{
            color: "#499AAF",
            marginRight: '5px',
          }}
        />
        {content}
      </Modal.Body>
    </Modal>
  );
}

export default ModalLoading;